export default "__VITE_PUBLIC_ASSET__132e248a__"